var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneralIconsCopy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10,0H4.75A1.752,1.752,0,0,1,3-1.75V-11H.75a.75.75,0,0,0-.75.75V1.25A.75.75,0,0,0,.75,2h8.5A.75.75,0,0,0,10,1.25Zm0-10.75V-14H4.75a.75.75,0,0,0-.75.75v11.5A.75.75,0,0,0,4.75-1h8.5A.75.75,0,0,0,14-1.75V-10H10.75A.752.752,0,0,1,10-10.75Zm3.78-.97L11.72-13.78a.748.748,0,0,0-.53-.22H11v3h3v-.189A.748.748,0,0,0,13.78-11.72Z",
    transform: "translate(0 14)",
    fill: "#888075"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralIconsCopy);
export default __webpack_public_path__ + "static/media/generalIcons_Copy.4418a12135b178829d8352acc5fb500c.svg";
export { ForwardRef as ReactComponent };